import { render } from "./TopsSc.vue?vue&type=template&id=ab6496b0&scoped=true"
import script from "./TopsSc.vue?vue&type=script&lang=js"
export * from "./TopsSc.vue?vue&type=script&lang=js"

import "./TopsSc.vue?vue&type=style&index=0&id=ab6496b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab6496b0"]])

export default __exports__